import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const ECASFOROR_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/ecasforor/logo.png",
        alt: "Eugene Center for Anxiety and Stress Logo",
        style: { width: "280px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 42,
  state: "OR",
  departmentIds: [267, 523],
};
